export const CONFIG = {
    // The key used to encrypt the data
    ENCRYPTION_KEY : process.env.REACT_APP_COOKIE_ENCRYPTION_KEY
}